<template>
  <div id="app">
    <inscripcion></inscripcion>
  </div>
</template>

<script>
import inscripcion from "./components/inscripcion";

export default {
  name: 'App',
  components: {inscripcion}
}
</script>

<style>
body {
  margin: 0;
  background-image: url("assets/img/background_index.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
